import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

const usePlanAndLDFlag = flagName => {
  const flags = useFlags();
  const merchantFlags = useSelector(state => state.auth.merchantFlags);
  return flags[flagName] && !!merchantFlags?.[flagName]?.enabled;
};

export default usePlanAndLDFlag;
